<template lang="pug">
  .product-feature(ref="root")
    DynamicMedia.product-feature-image(
      v-if="imageConfig"
      :config="imageConfig"
      :contain="true"
      :widths="[626, 1284]"
    )
    .product-feature-heading
      .number(v-show='number')
        span {{ number }}
      h4(v-if="title") {{ __(title, 'auto') }}
    slot(name="description")
</template>

<script setup lang="ts">
import { computed, ref, inject, type PropType, type Ref } from 'vue'

const props = defineProps({
  title: {
    type    : String,
    default : '',
  },
  image: {
    type     : Object as PropType<Record<string, unknown> | undefined>,
    required : false,
  },
})

const root = ref<HTMLElement | null>(null)

const numbered = inject<boolean>('productFeatureNumbered', true)
const startNumberAt = inject<string>('productFeatureStartNumberAt', '1')

const number = computed<number | false>(() => {
  if (numbered) {
    const base = parseInt(startNumberAt || '1', 10) || 1

    if (root.value?.parentElement) {
      const siblings = Array.from(root.value.parentElement.children)
      const index = siblings.indexOf(root.value)

      return base + index
    }
  }

  return false
})

const imageConfig = computed<Record<string, unknown> | undefined>(() => {
  if (!props.image) {
    return undefined
  }

  if ((props.image as any).alt) {
    return props.image as Record<string, unknown>
  }

  return {
    ...(props.image as Record<string, unknown>),
    alt: props.title,
  }
})
</script>
<style lang="scss">
.product-feature p:last-child {
  margin-bottom: 0;
}
</style>

<style lang='scss' scoped>

.product-feature-image {
  margin-bottom: $space-s;

  &:deep(img) {
    width: 100%;
  }
}

.product-feature-heading {
  margin-bottom: $space-xs;
  display: flex;
  align-items: flex-start;
}

.number {
  color: $color-white;
  flex-shrink: 0;
  background: $color-red;
  border-radius: 50%;
  width: $size-l;
  height: $size-l;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: $space-xxxs;
  font-size: $size-xs;
}

</style>
